import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "connectCarFilled"
const ConnectCarFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M9.75 7.5C11.84 7.5 13.225 7.796 14.115 8.116 14.559 8.276 14.878 8.441 15.096 8.578 15.206 8.646 15.29 8.708 15.35 8.756L15.426 8.82 15.452 8.843 15.462 8.853 15.47 8.858 14.996 9.34 15.47 8.86 15.61 8.997 16.367 11.625H18C18 12.351 17.484 12.955 16.799 13.095L17.872 14.688 18 14.879V21C18 21.414 17.664 21.75 17.25 21.75H15C14.586 21.75 14.25 21.414 14.25 21V20.25H5.25V21C5.25 21.414 4.914 21.75 4.5 21.75H2.25C1.836 21.75 1.5 21.414 1.5 21V14.913L1.594 14.743H1.595Q1.595 14.741 1.597 14.737L1.603 14.727 1.628 14.682 1.718 14.526C1.794 14.396 1.9 14.216 2.021 14.021 2.197 13.738 2.437 13.374 2.673 13.088 2.003 12.938 1.5 12.34 1.5 11.625H3.107C3.22 11.228 3.33 10.847 3.43 10.509 3.548 10.117 3.651 9.782 3.724 9.545L3.811 9.267 3.834 9.193 3.841 9.173 3.842 9.168 3.843 9.166 3.899 8.99 4.029 8.86 4.559 9.393C4.057 8.887 4.03 8.86 4.03 8.859L4.038 8.852 4.048 8.842 4.074 8.82 4.149 8.756Q4.24 8.682 4.403 8.578C4.622 8.441 4.941 8.276 5.386 8.116 6.275 7.796 7.66 7.5 9.75 7.5M4.125 15.75V17.625H7.125V17.25C7.125 16.422 6.453 15.75 5.625 15.75zM13.875 15.75C13.047 15.75 12.375 16.422 12.375 17.25V17.625H15.375V15.75zM9.75 9C7.8 9 6.591 9.276 5.894 9.527 5.547 9.652 5.324 9.771 5.2 9.85L5.157 9.989C5.085 10.222 4.984 10.552 4.868 10.938 4.718 11.444 4.544 12.044 4.38 12.643H15.1L14.293 9.844C14.166 9.767 13.946 9.65 13.606 9.527 12.91 9.277 11.7 9 9.75 9"
            clipRule="evenodd"
          />
          <path d="M14.381 4.19C15.538 4.362 16.621 4.87 17.493 5.647 18.366 6.425 18.993 7.442 19.296 8.572 19.403 8.972 19.166 9.383 18.766 9.491S17.953 9.36 17.845 8.96C17.62 8.112 17.15 7.35 16.496 6.765S15.028 5.803 14.16 5.674C13.75 5.613 13.469 5.231 13.529 4.822 13.59 4.412 13.972 4.13 14.381 4.19M15 1.125C15.985 1.125 16.96 1.319 17.87 1.695 18.78 2.073 19.607 2.626 20.303 3.323 21 4.018 21.554 4.845 21.93 5.755 22.306 6.665 22.5 7.64 22.5 8.625 22.5 9.039 22.164 9.375 21.75 9.375S21 9.039 21 8.625C21 7.837 20.845 7.057 20.543 6.329S19.8 4.939 19.243 4.382 18.024 3.384 17.296 3.082C16.568 2.781 15.788 2.625 15 2.625 14.586 2.625 14.25 2.289 14.25 1.875S14.586 1.125 15 1.125" />
        </svg>
      }
    </span>
  )
}
export default ConnectCarFilledIcon
